










































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
const html2pdf = require("../lib/html2pdf.bundle.js");
import { LearningApi } from "@/services/learning.api.service";
import Cards from "@/components/Cards.vue";
import MobileFilters from "@/components/MobileFilters.vue";

@Component({
    components: {
        Cards,
        MobileFilters,
    },
})
export default class MyTrials extends Vue {
    //   public route: string = 'http://33422.s.time4vps.cloud/cmlearning/wp-json/wp/v2/';
    public path: string = "https://www.codemotion.com/learning/tp/";
    public hideMobileFilters: boolean = false;
    public courses: any = [];
    public subscribed: any = [];
    public user: any = {
        courses: [],
    };
    public userChallenges: any = [];
    public userHackathons: any = [];
    public userPaths: any = [];
    public filterPrograms: string = "new";
    public filterStatus: string = "all";
    public isLoading: boolean = false;

    public careerPaths: any = [];
    statusAvailable: any[] = [];
    certificate: any = {};

    public tab: string = "challenges";

    @Watch("tab")
    onTabChange(val) {
        this.$router.push({ query: { tab: val } });
        this.loadSwitch(val);
    }

    public get route() {
        return this.$store.getters.conf.learning_bo_api + "/wp/v2/";
    }

    public loadSwitch(tab) {
        switch (tab) {
            case "training":
                !this.courses.length && this.loadTrainings();
                break;
            case "challenges":
                !this.userChallenges.length && this.loadChallenges();
                break;
            case "hackathons":
                !this.userHackathons.length && this.loadHackathons();
                break;
        }
    }

    public checkUrlQuery() {
        return (
            this.$route.query.tab &&
            (this.$route.query.tab === "challenges" ||
                this.$route.query.tab === "training" ||
                this.$route.query.tab === "hackathons")
        );
    }

    public async mounted() {
        if (this.$route.query.tab) {
            this.tab = <any>this.$route.query.tab;
        }
        this.loadSwitch(this.tab);
        this.loadCareerPaths();
    }

    public lp: any[] = [];

    public async loadCareerPaths() {
        this.isLoading = true;
        try {
            const res = await (<any>this.$workApi).getCareerPaths();
            this.careerPaths = res;

            this.careerPaths.forEach((cp) =>
                this.lp.push(...cp.learning_paths)
            );
        } catch (error) {
            console.error(error);
        } finally {
            this.isLoading = false;
        }
    }

    public async loadChallenges() {
        this.isLoading = true;
        try {
            const participations = await (<any>(
                this.$challengeApi
            )).getParticipations();

            const participationIds = participations.map(
                (el) => el.ext_challenge_id
            );

            this.userChallenges = (<any>await this.$eventsApi.eventsList({
                ext_ids: participationIds,
                type: "coding_challenge",
            })).data;
        } catch (error) {
            console.error(error);
        } finally {
            this.isLoading = false;
        }
    }

    public async loadHackathons() {
        this.isLoading = true;
        try {
            const hackathons = await (<any>this.$hackathonApi).getHackathons();

            this.userHackathons = hackathons.data;
        } catch (error) {
            console.error(error);
        } finally {
            this.isLoading = false;
        }
    }

    public async loadTrainings() {
        this.isLoading = true;
        LearningApi.getCourses()
            .then((boCourses) => {
                const tempC = boCourses.filter((el) => {
                    return !this.lp.find((cp) => cp.id === el.id);
                });
                this.courses = tempC;
            })
            .catch((error) => {
                this.isLoading = false;
                console.error(error);
            });
        try {
            this.user = await LearningApi.getUserEnrollments();
        } catch (error) {
            console.error(error);
        }
        if (
            this.user.courses &&
            Array.isArray(this.user.courses) &&
            this.user.courses.length > 0
        ) {
            let courses: any = this.user.courses.filter((el) => {
                return !this.lp.find((cp) => cp.id === el.id);
            });
            let ids = "";
            for (let el in courses) {
                if (<any>el !== 0) {
                    ids = ids + "," + courses[el].id;
                } else {
                    ids = courses[el].id;
                }
                if (
                    this.statusAvailable.includes(courses[el].status) === false
                ) {
                    this.statusAvailable.push(courses[el].status);
                }
            }
            LearningApi.getFilteredCoursesByIds(ids)
                .then((sCourses) => {
                    this.subscribed = sCourses;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.error(error);
                });
        }
        this.isLoading = false;
    }

    public filterCourse(course_id, status) {
        let check = false;

        if (
            this.filterPrograms === "new" &&
            status === "none" &&
            this.isEnrolled(course_id) === false
        ) {
            check = true;
        }

        if (this.filterPrograms === "sub") {
            let user_status = this.getStatus(course_id);

            switch (this.filterStatus) {
                case "completed":
                    if (user_status === "completed") {
                        check = true;
                    }
                    break;
                case "ongoing":
                    if (user_status === "accepted" && status !== "closed") {
                        check = true;
                    }
                    break;
                case "pending":
                    if (user_status === "pending" && status !== "closed") {
                        check = true;
                    }
                    break;
                case "notcompleted":
                    if (user_status !== "completed" && status === "closed") {
                        check = true;
                    }
                    if (user_status === "refused") {
                        check = true;
                    }
                    break;
                default:
                    //all
                    check = true;
                    break;
            }
        }
        return check;
    }

    public isEnrolled(id) {
        if (this.user.courses !== "") {
            let courses = this.user.courses;
            let check = false;

            for (let el in courses) {
                if (+courses[el].id === +id) {
                    check = true;
                }
            }
            return check;
        }
    }

    public isFilterEnabled(filter) {
        let check = false;

        switch (filter) {
            case "completed":
                if (this.statusAvailable.includes("completed") === true) {
                    check = true;
                }
                break;
            case "ongoing":
                if (this.statusAvailable.includes("accepted") === true) {
                    check = true;
                }
                break;
            case "pending":
                if (this.statusAvailable.includes("pending") === true) {
                    check = true;
                }
                break;
            case "notcompleted":
                if (this.statusAvailable.includes("refused") === true) {
                    check = true;
                }
                break;
            default:
                //all
                check = false;
                break;
        }

        return check;
    }

    public areCompleted() {
        let courses = this.user.courses;
        let check = false;

        if (courses !== "") {
            for (let el in courses) {
                if (courses[el].status === "completed") {
                    check = true;
                }
            }
        }
        return check;
    }

    public areClosed() {
        let courses: any = this.subscribed;
        let check = false;
        let arr: any = [];

        if (courses !== "") {
            for (let el in courses) {
                if (courses[el].cl_fields.course_status.status === "closed") {
                    arr.push(courses[el].id);
                }
            }

            for (let key in arr) {
                for (let el in this.user.courses) {
                    if (
                        +this.user.courses[el].id === +arr[key] &&
                        this.user.courses[el].status !== "completed"
                    ) {
                        check = true;
                    }
                }
            }
        }
        return check;
    }

    public getStatus(course_id) {
        let courses = this.user.courses;
        let status = "";

        for (let el in courses) {
            if (+courses[el].id === +course_id) {
                status = courses[el].status;
            }
        }

        Object.getOwnPropertyNames(courses).forEach(function (el) {
            if (+courses[el].id === +course_id) {
                status = courses[el].status;
            }
        });
        return status;
    }

    public getStatusLabel(course_id, status, css = false) {
        let user_status = this.getStatus(course_id);
        let label = "";

        if (css === false) {
            switch (user_status) {
                case "completed":
                    label = "Completed";
                    break;
                case "accepted":
                    label = "Ongoing";
                    if (status === "closed") {
                        label = "Closed";
                    }
                    break;
                case "pending":
                    label = "Pending";
                    if (status === "closed") {
                        label = "Closed";
                    }
                    break;
                case "refused":
                    label = "Not Accepted";
                    break;
                default:
                    //all
                    break;
            }
        } else {
            switch (user_status) {
                case "completed":
                    label = "#417505";
                    break;
                case "accepted":
                    label = "#266FE1";
                    if (status === "closed") {
                        label = "#878787";
                    }
                    break;
                case "pending":
                    label = "#E19626";
                    if (status === "closed") {
                        label = "#878787";
                    }
                    break;
                case "refused":
                    label = "#878787";
                    break;
                default:
                    //all
                    break;
            }
        }

        return label;
    }

    public getCPStatusLabel(activity, css = false) {
        if (activity === null) {
            if (css) {
                return "#E19626";
            }
            return "Not started";
        }
        let label = "";
        let perc = parseInt(activity.split("%")[0]);
        if (css === false) {
            switch (perc) {
                case 100:
                    label = "Completed";
                    break;
                default:
                    label = "Ongoing";
                    break;
            }
        } else {
            switch (perc) {
                case 100:
                    label = "#417505";
                    break;
                default:
                    label = "#266FE1";
                    break;
            }
        }

        return label;
    }

    public getProgress(course_id, course_el) {
        let courses = this.user.courses;
        let elements = "";
        let progress: number = 0;
        for (let key in courses) {
            if (+courses[key].id === +course_id) {
                elements = courses[key].activities;
            }
        }

        if (elements !== "") {
            let arr = elements.split(",");
            let done = arr.filter(el => el).length;

            progress = course_el > 0 ? (done / course_el) * 100 : 0;
        }

        return progress.toFixed();
    }

    public getBadgeLogoURL(badge_url) {
        if (badge_url === "") {
            return "https://www.codemotion.com/img/default-badge-certificate.svg";
        } else {
            return badge_url;
        }
    }

    public getPageBadgeURL(course_id) {
        let courses = this.user.courses;
        let url = "";

        if (courses !== "") {
            for (let el in courses) {
                if (+courses[el].id === +course_id) {
                    url = courses[el].badge;
                }
            }
        }
        return url;
    }

    public getLanguage(lang_code) {
        switch (lang_code) {
            case "it":
                return "Italian";
                break;
            case "fr":
                return "French";
                break;
            case "de":
                return "German";
                break;
            case "es":
                return "Spanish";
                break;
            default:
                return "English";
                break;
        }
    }

    public getDate(timestamp) {
        let myDate = new Date(timestamp * 1000);
        let options = { year: "numeric", month: "long", day: "numeric" };

        return myDate.toLocaleDateString(window.navigator.language, options);
    }

    public getCertificate(course_id) {
        let courses = this.subscribed;
        let tempCert = new Object();

        for (let el in courses) {
            if (+courses[el].id === +course_id) {
                tempCert["title"] = courses[el].title.rendered;
                tempCert["partner_logo"] =
                    courses[
                        el
                    ].cl_fields.course_details_metabox.course_partner_logo_dark;
                tempCert["background"] =
                    courses[
                        el
                    ].cl_fields.course_language_metabox.course_certificate;
                tempCert["badge"] =
                    courses[el].cl_fields.course_language_metabox.course_badge;
            }
        }

        courses = this.user.courses;

        for (let el in courses) {
            if (+courses[el].id === +course_id) {
                tempCert["name"] = courses[el].name;
                tempCert["date"] = courses[el].completeDate;
                tempCert["link"] = courses[el].badge;
            }
        }

        this.certificate = tempCert;
        this.generateCertificate();
    }

    public generateCertificate() {
        const certEl = document.getElementById("certificate");
        if (certEl) {
            certEl.style.display = "block";
            html2pdf(certEl, {
                filename: "certificate.pdf",
                jsPDF: { orientation: "landscape", format: [420, 320] },
                html2canvas: {
                    letterRendering: true,
                    useCORS: true,
                    imageTimeout: 0,
                },
            }).then(function (pdf) {
                certEl.style.display = "none";
            });
        }
    }

    public toggleMobileFilters() {
        if (this.hideMobileFilters === true) {
            this.hideMobileFilters = false;
        } else {
            this.hideMobileFilters = true;
        }
    }

    public getCourseLink(course) {
        return this.path + course.slug + "-" + course.id;
    }
    public getCourseImg(course) {
        return course.img || "/img/event-banner-default.jpg";
    }

    public get availableCourses() {
        return this.courses.filter((course) => {
            return (
                this.filterCourse(
                    course.id,
                    course.cl_fields.course_status.status
                ) === true
            );
        });
    }

    public get completedCourses() {
        return this.subscribed.filter((course) => {
            return this.getStatus(course.id) === "completed";
        });
    }

    public get filteredSubscribedCourses() {
        return this.subscribed.filter((course) => {
            return (
                this.filterCourse(
                    course.id,
                    course.cl_fields.course_status.status
                ) === true
            );
        });
    }
}
